import moment, { Moment } from "moment";

export const formatDate = (date?: string | Moment) => {
  return moment(date).format("YYYY-MM-DD");
};
